<template>
  <div class="home-page">
    <!-- ── 通知栏 ── -->
    <div class="notice-bar" v-if="noticeList.length > 0">
      <el-carousel height="36px" direction="vertical" :interval="4000">
        <el-carousel-item v-for="(item, index) in noticeList" :key="index">
          <div class="notice-item">
            <img class="notice-icon" src="/static/image/ic_notice.png" />
            <span class="notice-text">
              {{ item.noticeType == "2" ? "【公告】" : "【通知】" }}{{ item.noticeContent }}
            </span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- ── HERO Carousel ── -->
    <section class="hero-section">
      <div class="hero-card-wrapper">
        <el-carousel class="hero-carousel" :interval="4000" arrow="hover" indicator-position="inside" height="100%">
          <!-- default first slide -->
          <!-- <el-carousel-item>
            <div class="hero-card">
              <img class="hero-card-img" src="/static/image/home/hero_banner.png" alt="临床处方与中药配送一体化平台" />
            </div>
          </el-carousel-item> -->
          <!-- API carousel items -->
          <el-carousel-item v-for="(item, index) in swipers" :key="index">
            <div class="hero-card" @click="goCarouselLink(item.linkUrl)">
              <img class="hero-card-img" :src="item.imageUrl" :alt="item.title || ''" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>

    <!-- ── 核心服务 (4:4 双区：专业服务 + 健康服务) ── -->
    <section class="services-section">
      <div class="section-inner">
        <div class="section-title-wrap">
          <img class="title-deco" src="/static/image/home/title_deco_left.png" alt="" />
          <h2 class="section-title">核心服务</h2>
          <img class="title-deco" src="/static/image/home/title_deco_right.png" alt="" />
        </div>

        <div class="services-groups">
          <!-- 专业服务 -->
          <div class="services-group">
            <h3 class="group-title">专业服务</h3>
            <div class="services-grid">
              <div class="service-card" @click="gridClick(6)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_formula.png" alt="古中医组方" />
                </div>
                <span class="svc-name">古中医组方</span>
              </div>
              <div class="service-card" @click="gridClick(4)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_acupuncture.png" alt="中医针灸" />
                </div>
                <span class="svc-name">中医针灸</span>
              </div>
              <div class="service-card" @click="gridClick3(8)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_custom.png" alt="自拟组方" />
                </div>
                <span class="svc-name">自拟组方</span>
              </div>
              <div class="service-card" @click="gridClick(-1)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_solar.png" alt="24节气通用方" />
                </div>
                <span class="svc-name">24节气通用方</span>
              </div>
              <!-- <div class="service-card" @click="goChaoWeiPrescription()">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_formula.png" alt="超微饮品处方" />
                </div>
                <span class="svc-name">超微饮品处方</span>
              </div> -->
            </div>
          </div>

          <!-- 健康服务 -->
          <div class="services-group">
            <h3 class="group-title">健康服务</h3>
            <div class="services-grid">
              <div class="service-card" @click="gridClick(1)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_health.png" alt="健康预测" />
                </div>
                <span class="svc-name">健康预测</span>
              </div>
              <div class="service-card" @click="gridClick2(11)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_soup.png" alt="六气汤" />
                </div>
                <span class="svc-name">六气汤</span>
              </div>
              <div class="service-card" @click="gridClick2(9)">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_tea.png" alt="私人定制养生茶" />
                </div>
                <span class="svc-name">私人定制养生茶</span>
              </div>
              <div class="service-card" @click="goChaoWeiPrescription()">
                <div class="svc-icon-box">
                  <img class="svc-icon" src="/static/image/home/svc_food.png" alt="药食同源" />
                </div>
                <span class="svc-name">药食同源调理方案</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ── 百草元和的优势 (4 列) ── -->
    <section class="why-section">
      <div class="section-inner">
        <div class="section-title-wrap">
          <img class="title-deco" src="/static/image/home/title_deco_left.png" alt="" />
          <h2 class="section-title">百草元和的优势</h2>
          <img class="title-deco" src="/static/image/home/title_deco_right.png" alt="" />
        </div>

        <div class="why-grid">
          <div class="why-item">
            <div class="why-icon-circle">
              <img class="why-icon" src="/static/image/home/why_doctor.png" alt="古中医服务" />
            </div>
            <div class="why-text">
              <h3 class="why-title">古中医服务</h3>
              <p class="why-desc">三元融合医疗，提供精准健康诊疗方案</p>
            </div>
          </div>

          <div class="why-item">
            <div class="why-icon-circle">
              <img class="why-icon" src="/static/image/home/why_platform.png" alt="一体化平台" />
            </div>
            <div class="why-text">
              <h3 class="why-title">一体化平台</h3>
              <p class="why-desc">处方、配药、配送全流程线上闭环，降本增效，省时省心更省力</p>
            </div>
          </div>

          <div class="why-item">
            <div class="why-icon-circle">
              <img class="why-icon" src="/static/image/home/why_security.png" alt="安全合规" />
            </div>
            <div class="why-text">
              <h3 class="why-title">安全合规</h3>
              <p class="why-desc">严格遵循国家中医药管理规范，用药安全有保障，全流程可溯源</p>
            </div>
          </div>

          <div class="why-item">
            <div class="why-icon-circle">
              <img class="why-icon" src="/static/image/home/why_easy.png" alt="便捷触达" />
            </div>
            <div class="why-text">
              <h3 class="why-title">便捷触达</h3>
              <p class="why-desc">打通同城同后一公里，送药到家，享受高质量中药服务</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ── 百草学堂 · 健康科普 (2×2 横卡) ── -->
    <section class="articles-section">
      <div class="section-inner">
        <div class="section-title-wrap">
          <img class="title-deco" src="/static/image/home/title_deco_left.png" alt="" />
          <div class="section-title-stack">
            <span class="title-line">百草学堂</span>
            <span class="title-dot">·</span>
            <span class="title-line">健康科普</span>
          </div>
          <img class="title-deco" src="/static/image/home/title_deco_right.png" alt="" />
        </div>

        <div class="articles-grid">
          <article class="article-card" v-for="(item, index) in articleList" :key="index"
            @click="goArticleDetail(item)">
            <div class="article-img-box">
              <img :src="item.infoImage" class="article-img" alt="" />
            </div>
            <div class="article-body">
              <h3 class="article-title">{{ item.infoTitle }}</h3>
              <div class="article-meta">
                <span class="meta-item" v-if="item.createTime">发布时间：{{ item.createTime.substring(0, 10) }}</span>
              </div>
            </div>
          </article>
        </div>

        <div class="articles-more-wrap" @click="goClass">
          <span class="articles-more">查看更多 ›</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { EventBus } from "../../js/eventbus.js";
import Vue from "vue";
import router from "../../router";
import App from "../../App";
export default {
  components: {
    swiper,
    swiperSlide,
    Vue,
  },
  data() {
    return {
      swiperIndex: "1",
      swiperOptions: {
        show_indicators: false,
        autoplay: true,
        effect: "slide",
        slidesPerView: "auto",
        centeredSlides: true,
        autoplay: {
          delay: 3000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "custom",
        },
      },
      swipers: [],
      noticeList: [],
      articleList: [],
      ordinary: 0,
    };
  },
  created() {
    EventBus.$emit("refresh", "home");
    this.wjtHttp.get(this, "/api/home/v1/carousel", {}, false, (res) => {
      var data = res.data;
      if (data.code == 200) {
        this.swipers = data.data;
      } else {
        this.$message({
          message:
            data.msg && data.msg.length > 0
              ? data.msg
              : "信息获取异常，请联系管理员",
          type: "error",
        });
      }
    });
    this.wjtHttp.get(this, "/api/home/v1/notice", {}, false, (res) => {
      var data = res.data;
      if (data.code == 200 && !this.utils.isEmptyStr(data.rows)) {
        this.noticeList = data.rows;
      }
    });
    this.wjtHttp.get(
      this,
      "/api/home/v1/course?pageNum=1&pageSize=4",
      {},
      false,
      (res) => {
        var data = res.data;
        if (data.code == 200 && !this.utils.isEmptyStr(data.rows)) {
          this.articleList = data.rows;
        } else {
          this.$message({
            message:
              data.msg && data.msg.length > 0
                ? data.msg
                : "科普文章获取异常，请联系管理员",
            type: "error",
          });
        }
      }
    );
  },
  mounted() {
  },
  methods: {
    slideChangeEnd() {
      this.swiperIndex = parseInt(this.$refs.mySwiper.swiper.activeIndex);
    },
    touchEnd() {
      this.swiperIndex = parseInt(this.$refs.mySwiper.swiper.activeIndex);
    },
    goCarouselLink(item) {
      if (item) {
        window.open(item, '_blank');
      }
    },
    goNews() {
      this.$router.push('/News');
    },
    goClass() {
      this.$router.push('/Class');
    },
    goArticleDetail(item) {
      if (!this.utils.isEmptyStr(item.infoUrl)) {
        window.open(item.infoUrl, '_blank');
      }
    },

    isUserTypeByValue(roles, val) {
      for (var i = 0; i < roles.length; i++) {
        var value = roles[i];
        if (value == val) {
          return true;
        }
      }
      return false;
    },
    gnwkf() {
      this.$message.error("该功能为付费版，使用请联系管理员");
    },
    gridClick2(flag) {
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
      var token = this.$cookies.get("token");
      if (!token || token.length == 0) {
        this.$router.push({ path: "/login" });
      } else {
        var userInfo = this.$store.getters.getUserInfo;
        var role = "common";
        var roles = userInfo.roles;
        if (
          (this.isUserTypeByValue(roles, "doctor") &&
            userInfo.doctor.status === "0") ||
          (this.isUserTypeByValue(roles, "doctor") &&
            userInfo.doctor.status === "4")
        ) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "admin")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "superadmin")) {
          role = "doctor";
        }

        if (this.isUserTypeByValue(roles, "level1")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "level2")) {
          role = "doctor";
        }

        if (this.isUserTypeByValue(roles, "level2")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "common_doctor")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "common_hospital_admin")) {
          role = "doctor";
        }

        console.log("role88888888888", role);

        if (!(role === "doctor") && !(flag === 9 && role === "common")) {
          console.log("rol9999999", role);
          this.$message.error("没有开方权限");
        } else {
          console.log("role0000000000", role);
          this.$router.push({
            path: "/addServiceContact",
            query: {
              serviceIndex: flag,
            },
          });
        }
      }
    },
    gridClick3() {
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
      var token = this.$cookies.get("token");
      if (!token || token.length == 0) {
        this.$router.push({ path: "/login" });
      } else {
        var userInfo = this.$store.getters.getUserInfo;
        var role = "common";
        var roles = userInfo.roles;
        if (
          (this.isUserTypeByValue(roles, "doctor") &&
            userInfo.doctor.status === "0") ||
          (this.isUserTypeByValue(roles, "doctor") &&
            userInfo.doctor.status === "4")
        ) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "admin")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "superadmin")) {
          role = "doctor";
        }

        if (this.isUserTypeByValue(roles, "level1")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "level2")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "common_doctor")) {
          role = "doctor";
        }
        console.log("role88888888888", role);

        if (!(role === "doctor")) {
          console.log("rol9999999", role);
          this.$message.error("没有开方权限");
        } else {
          console.log("role0000000000", role);
          this.$router.push({
            path: "/commonAddPrescriptionContact",
            query: {
              mode: 2,
            },
          });
        }
      }
    },
    gridClick(flag) {
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
      var token = this.$cookies.get("token");

      if (flag == 8) {
        if (!token || token.length == 0) {
          this.$router.push({ path: "/login" });
        } else {
          var userInfo = this.$store.getters.getUserInfo;
          var role = "common";
          var roles = userInfo.roles;
          if (
            (this.isUserTypeByValue(roles, "doctor") &&
              userInfo.doctor.status === "0") ||
            (this.isUserTypeByValue(roles, "doctor") &&
              userInfo.doctor.status === "4")
          ) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "admin")) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "superadmin")) {
            role = "doctor";
          }

          if (this.isUserTypeByValue(roles, "level1")) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "level2")) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "common_doctor")) {
            role = "doctor";
          }
          console.log("role88888888888", role);

          if (!(role === "doctor")) {
            console.log("rol9999999", role);
            this.$message.error("没有开方权限");
          } else {
            console.log("role0000000000", role);
            this.$router.push({
              path: "/addPrescriptionContact",
              query: {
                mode: 2,
              },
            });
          }
        }
      } else if ((flag < 6 && flag > -1) || flag == 12) {
        this.$router.push({
          path: "/addServiceContact",
          query: {
            serviceIndex: flag,
          },
        });
      } else if (flag == 6 || flag == -1) {
        if (!token || token.length == 0) {
          this.$router.push({ path: "/login" });
        } else {
          var userInfo = this.$store.getters.getUserInfo;
          var role = "common";
          var roles = userInfo.roles;
          if (
            (this.isUserTypeByValue(roles, "doctor") &&
              userInfo.doctor.status === "0") ||
            (this.isUserTypeByValue(roles, "doctor") &&
              userInfo.doctor.status === "4")
          ) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "admin")) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "superadmin")) {
            role = "doctor";
          }

          if (this.isUserTypeByValue(roles, "level1")) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "level2")) {
            role = "doctor";
          }
          if (this.isUserTypeByValue(roles, "common_doctor")) {
            role = "doctor";
          }
          console.log("role88888888888", role);

          if (!(role === "doctor")) {
            console.log("rol9999999", role);
            this.$message.error("没有开方权限");
          } else {
            console.log("role0000000000", role);
            this.$router.push({
              path: "/addPrescriptionContact",
              query: {
                serviceIndex: flag,
              },
            });
          }
        }
      } else {
        this.$message.error("功能待开放");
      }
    },
    goChaoWeiPrescription() {
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
      var token = this.$cookies.get("token");
      if (!token || token.length == 0) {
        this.$router.push({ path: "/login" });
      } else {
        var userInfo = this.$store.getters.getUserInfo;
        var role = "common";
        var roles = userInfo.roles;
        if (
          (this.isUserTypeByValue(roles, "doctor") &&
            userInfo.doctor.status === "0") ||
          (this.isUserTypeByValue(roles, "doctor") &&
            userInfo.doctor.status === "4")
        ) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "admin")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "superadmin")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "level1")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "level2")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "common_doctor")) {
          role = "doctor";
        }
        if (this.isUserTypeByValue(roles, "common_hospital_admin")) {
          role = "doctor";
        }

        if (!(role === "doctor")) {
          this.$message.error("没有开方权限");
        } else {
          this.$router.push({
            path: "/chaoweiContact",
          });
        }
      }
    },
  },
};
</script>

<style scoped>
/* ============================================================
   Home page – PSD-based redesign (1920×3128)
   Key colors: #1a1a1a #20863F #f5f7f2 #fff #666 #999
   ============================================================ */

/* ── Shared ── */
.home-page {
  width: 100%;
}

.section-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 48px;
}

.section-title {
  font-size: 30px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 4px;
  margin: 0;
  white-space: nowrap;
}

.title-deco {
  height: 16px;
  width: auto;
  flex-shrink: 0;
  display: block;
}

.section-title-stack {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.title-line {
  font-size: 30px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 4px;
  line-height: 1.2;
}

.title-dot {
  font-size: 22px;
  color: #c8a96e;
  line-height: 1;
  padding: 6px 0;
}

/* ── Notice Bar ── */
.notice-bar {
  width: 100%;
  background: #fef9ef;
  border-bottom: 1px solid #f0e6d0;
}

.notice-bar>>>.el-carousel__item {
  display: flex;
  align-items: center;
}

.notice-item {
  display: flex;
  align-items: center;
  height: 36px;
  justify-content: center;
}

.notice-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.notice-text {
  font-size: 14px;
  color: #8a6d3b;
}

/* ── HERO ── */
.hero-section {
  position: relative;
  width: 100%;
  padding: 30px 0 70px;
  background: #fff;
  overflow: hidden;
}

.hero-card-wrapper {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-carousel>>>.el-carousel__container {
  border-radius: 24px;
  position: relative;
  height: 0 !important;
  padding-bottom: 41.6%;
  overflow: hidden;
}

.hero-carousel>>>.el-carousel__item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-carousel>>>.el-carousel__indicator {
  padding: 6px 4px;
}

.hero-carousel>>>.el-carousel__indicator .el-carousel__button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  opacity: 1;
}

.hero-carousel>>>.el-carousel__indicator.is-active .el-carousel__button {
  background: #20863F;
}

.hero-carousel>>>.el-carousel__arrow {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  color: #20863F;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.hero-carousel>>>.el-carousel__arrow:hover {
  background: #fff;
}

.hero-card {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
  border-radius: 24px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  overflow: hidden;
}

.hero-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 24px;
}

/* ── Core Services ── */
.services-section {
  padding: 10px 0 64px;
}

.services-groups {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.services-group {
  display: flex;
  flex-direction: column;
}

.group-title {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  letter-spacing: 2px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.service-card {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 38px 40px;
  border-radius: 16px;
  border: 1px solid #e8ede8;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(42, 122, 75, 0.1);
  border-color: rgba(42, 122, 75, 0.3);
}

.svc-icon-box {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #f0f6f2;
  flex-shrink: 0;
  transition: background 0.3s ease;
}

.service-card:hover .svc-icon-box {
  background: #e2f0e6;
}

.svc-icon {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

.svc-name {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.3;
}

/* ── Why Choose ── */
.why-section {
  padding: 36px 0 72px;
  background: #fff;
}

.why-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 48px;
}

.why-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 22px;
}

.why-icon-circle {
  width: 116px;
  height: 116px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.why-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.why-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 10px 0;
}

.why-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin: 0;
  max-width: 240px;
}

/* ── Articles ── */
.articles-section {
  padding: 36px 0 80px;
}

.articles-more-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  cursor: pointer;
}

.articles-more {

  font-size: 24px;
  color: #20863F;
  cursor: pointer;
  transition: color 0.2s ease;
}

.articles-more:hover {
  color: #1f5f3a;
  text-decoration: underline;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.article-card {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 20px;
  padding: 23px 24px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: all 0.3s ease;
  background: #F9F9F9;
}

.article-card:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.article-img-box {
  flex-shrink: 0;
  width: 150px;
  height: 150px;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.article-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.article-card:hover .article-img {
  transform: scale(1.05);
}

.article-body {
  flex: 1;
  padding: 2px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.article-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-meta {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #9E9E9E;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* ── Responsive: Tablet (<=1024px) ── */
@media screen and (max-width: 1024px) {

  .section-inner,
  .hero-card-wrapper {
    max-width: 100%;
    padding-left: 24px;
    padding-right: 24px;
  }

  .hero-section {
    padding: 24px 0 48px;
  }

  .hero-card-wrapper {
    padding: 0 24px;
  }

  .hero-carousel>>>.el-carousel__container {
    border-radius: 18px;
  }

  .hero-card-img {
    border-radius: 18px;
  }

  .services-groups {
    grid-template-columns: 1fr;
    gap: 48px;
  }

  .why-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 36px;
  }

  .articles-grid {
    grid-template-columns: 1fr;
  }

  .article-img-box {
    width: 150px;
    height: 150px;
  }

  .title-line {
    font-size: 26px;
  }

  .section-title-stack {
    gap: 12px;
  }
}

/* ── Responsive: Mobile (<=640px) ── */
@media screen and (max-width: 640px) {
  .section-title {
    font-size: 22px;
    letter-spacing: 2px;
  }

  .section-title-wrap {
    margin-bottom: 32px;
    gap: 10px;
  }

  .title-deco {
    height: 12px;
  }

  .section-title-stack {
    gap: 8px;
  }

  .title-line {
    font-size: 22px;
    letter-spacing: 2px;
  }

  .title-dot {
    font-size: 18px;
  }

  /* HERO */
  .hero-section {
    padding: 16px 0 32px;
  }

  .hero-card-wrapper {
    padding: 0 16px;
  }

  .hero-carousel>>>.el-carousel__container {
    border-radius: 14px;
  }

  .hero-card-img {
    border-radius: 14px;
  }

  /* Services */
  .services-section {
    padding: 40px 0;
  }

  .services-groups {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .service-card {
    padding: 14px 12px;
    gap: 12px;
    border-radius: 10px;
  }

  .svc-icon-box {
    width: 42px;
    height: 42px;
    border-radius: 8px;
  }

  .svc-icon {
    max-width: 72%;
    max-height: 72%;
  }

  .svc-name {
    font-size: 13px;
    white-space: normal;
    word-break: break-word;
  }

  /* Why */
  .why-section {
    padding: 40px 0;
  }

  .why-grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .why-icon-circle {
    width: 90px;
    height: 90px;
  }

  .why-icon {
    width: 100%;
    height: 100%;
  }

  .why-title {
    font-size: 16px;
  }

  .why-desc {
    max-width: 100%;
  }

  /* Articles */
  .articles-section {
    padding: 40px 0;
  }

  .articles-more-wrap {
    padding-top: 28px;
  }

  .articles-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .article-card {
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  .article-img-box {
    width: 100%;
    height: 180px;
  }

  .article-body {
    padding: 0;
    min-height: auto;
  }

  .article-title {
    font-size: 16px;
    margin-bottom: 12px;
  }
}
</style>
